
import Vue from 'vue'
import { Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import { Sinister } from '../../../typescript/sinisters/sinisterInfo'
import Button from '../../../core/components/Generics/Button.vue'
import ItemIndicators from '../../../item/components/ItemIndicators.vue'
import { SinisterIndicatorsKeys } from '../../../../features/item_with_sinisters/indicators';
import { formatDate } from '../../../../features/core/utils/date-handlers';
import SatellitalEvolutionChart from '../../../../features/item_with_sinisters/components/satellital/SatellitalEvolutionChart.vue';
import SinisterMapLayers from '../../../../features/item_with_sinisters/components/sinisters/SinisterMapLayers.vue';
import InspectionSection from '../../../../features/item_with_sinisters/components/sinisters/inspection/InspectionSection.vue';
import SurfaceZonificationInfo from '../../../../features/item_with_sinisters/components/sinisters/surface-zonificacion/SurfaceZonificationInfo.vue';
import { ItemInfo } from '../../../../features/typescript/itemInfo';
import { SatellitalImage } from '../../../../features/typescript/satellital/satellital_images';
import { SatellitalLayersInfo } from '../../../../features/typescript/satellital/layers';
import { Note } from '../../../../features/typescript/notes/notes';
import { defaultUserPrivilege, PrivilegeValue } from '../../../../privileges/privileges';
@Component({
    components: {
        ItemIndicators,
        SinisterMapLayers,
        InspectionSection,
        SurfaceZonificationInfo,
        SatellitalEvolutionChart,
        Button
    }
})

export default class SinistersList extends Vue {
    @Prop({ default: () => [] }) sinisters!: Sinister[];
    @Prop({ default: () => null }) itemPolygon: ItemInfo["polygon"];
    @Prop({ default: () => defaultUserPrivilege }) privilege!: PrivilegeValue;
    indicators: SinisterIndicatorsKeys | null = null;
    panel: number[] = [];

    created() {
        if (this.sinisters.length > 0) {
            this.panel = [0];
        }
    }
    satellitalLayersInfo: SatellitalLayersInfo = {
        zonified: {
            date: null,
            png_url: null,
            total_area: null,
            bar_url: '',
            zones: [],
            bounds: null
        },
        ndvi: {
            initial_date: null,
            final_date: null,
            png_url: null,
            bar_url: '',
            total_area: null,
            zones: [],
            bounds: null
        }
    }

    pendingOps: { [k: string]: Array<(c:any)=>void> } = {};

    // Nota seleccionada / en hover por siniestro, compartida entre mapa y listado
    selectedNoteIds: { [sinisterId: number]: number | null } = {};
    hoveredNoteIds: { [sinisterId: number]: number | null } = {};

    selectNote(noteId: number | null, sinisterId: number) {
        this.$set(this.selectedNoteIds, sinisterId, noteId);
    }

    hoverNote(noteId: number | null, sinisterId: number) {
        this.$set(this.hoveredNoteIds, sinisterId, noteId);
    }

    key(refBase: string, id: number) {
        return `${refBase}-${id}`;
    }

    getRef(refBase: string, id: number) {
        const r = this.$refs[this.key(refBase, id)];
        return Array.isArray(r) ? r[0] : r || null;
    }

    onChildMounted(refBase: string, id: number) {
        const comp = this.getRef(refBase, id);
        const k = this.key(refBase, id);
        const q = this.pendingOps[k];
        if (comp && q && q.length) {
            q.forEach(run => run(comp));
            delete this.pendingOps[k];
        }
    }

    callChild(refBase: string, id: number, method: string, ...args: any[]) {
        const comp = this.getRef(refBase, id);
        if (comp && typeof comp[method] === 'function') {
            comp[method](...args);
            return;
        }
        // buffer hasta que el componente monte
        const k = this.key(refBase, id);
        (this.pendingOps[k] || (this.pendingOps[k] = []))
            .push((c) => c[method] && c[method](...args));
    }
    
    parseDate(value){
       return formatDate(value, false, true)
    }

    getIndicatorsForSinister(sinister: Sinister){
        return {
            creation_date: this.parseDate(sinister.creation_date),
            claim_id: sinister.claim_id,
            event_type: sinister.event_type,
            event_date: this.parseDate(sinister.event_date)
        }
    }

    seeNotesInMap(notes, sinisterId) {
        this.callChild('map', sinisterId, 'seeNotesInMap', notes);
    }


    //Actualizo props en los componentes hijos (DE LA INSTANCIA ACTUAL)
    //Cuando detecto click en un punto del grafico, actualizo la imagen satelital seleccionada
    onClickedChartPoint(pointIndex: number, id: number) {
        this.callChild('map', id, 'clickedSatelliteImage', pointIndex);
    }

    //Cuando cambia la imagen seleccionada en SinisterMapLayers actualizo el indice en el grafico
    updateCarouselIndex(idx: number, id: number) {
        this.callChild('chart', id, 'updateCarouselIndex', idx);
    }

    updateSelectedImageInChart(img, id: number) {
        this.callChild('chart', id, 'updateSelectedImage', img);
    }

    //Cuando cambia la banda seleccionada en SinisterMapLayers actualizo la prop en el grafico
    updateSelectedBandInChart(band, id: number) {
        this.callChild('chart', id, 'updateSelectedBand', band);
    }

    //Actualizo la informacion de las capas en los componentes hijos de la misma instancia
    updateLayersInfoInChilds(newLayers, id: number) {
        this.callChild('surface', id, 'updateLayersInfoZonified', newLayers.zonified);
        this.callChild('surface', id, 'updateLayersInfoNdvi', newLayers.ndvi);
        this.callChild('chart', id, 'updateSatellitalLayersInfo', newLayers);
    }

    updateLoadingZonification(v: boolean, id: number) {
        this.callChild('surface', id, 'updateLoadingZonification', v);
    }

    updateLoadingNdviDiff(v: boolean, id: number) {
        this.callChild('surface', id, 'updateLoadingNdviDiff', v);
    }

    //Actualizo la prop 'loading' en informacion de zonificacion y grafico
    updateLoadingMapInChilds(v: boolean, id: number) {
        this.callChild('chart', id, 'updateIsLoadingLayers', v);
        this.updateLoadingZonification(v, id);
        this.updateLoadingNdviDiff(v, id);
    }

    addRgbNdviToChart(values, id: number) {
     this.callChild('chart', id, 'setRgbAndNdviValues', values);
    }


}

